import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "total-footnote"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "**", -1 /* HOISTED */)
const _hoisted_3 = { class: "small text-muted" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.display_footer)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!$setup.footer_expanded)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "total-footnote-toggle",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.footer_expanded = true))
            }, [
              _createTextVNode(_toDisplayString(_ctx.__("About the estimated setup time")) + " · " + _toDisplayString(_ctx.__("Read")), 1 /* TEXT */),
              _hoisted_2
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" One __() per line, each with its own row in this app's CSVs. The \"**\" marker\n\t\t     stays outside the key: it ties the note to the \"Setup time\" total. "),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, "**" + _toDisplayString(_ctx.__("The installation time is indicative but is an estimate for a simple standard installation by your chosen VAR Expert.")), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.__("In this order, you do not commit to this non valued part.")), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.__("An audit of your activity, a flow analysis, and a set of specifications will allow you to adjust this indicative time.")), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.__("(Expect significant variations in time depending on the requests or needs).")), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.__("Your chosen VAR Expert will propose a training plan, here not included, according to the teams and functions.")), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.__("Standard reports are provided but usually need to be adapted. This time is not counted in the implementation time.")), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.__("If there are modules offered for free or included, they also require installation and training time.")), 1 /* TEXT */)
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}